const SelectFilter = require("app/components/filters/SelectFilter");

class Filter extends SelectFilter {

	get options() {
		return [
			{
				title: "Unisex",
				value: "unisex"
			},
			{
				title: translate("Til Ham"),
				value: "men"
			},
			{
				title: translate("Til Hende"),
				value: "women"
			}
		];
	}

	get placeholder() {
		return translate("Alle");
	}
	
}

module.exports = Filter;
